import { createReducer } from '@reduxjs/toolkit';
import { handleActionStart, handleActionError } from 'store/utils';
import {
  setCurrentPatient,
  clearCurrentPatient,
} from 'store/currentPatient/actions';

import { fetchFhirLabTicks } from 'store/currentPatient/actions/fhir';

const initialState = {
  data: {},
  isLoading: false,
  error: null,
};

export default createReducer(initialState, {
  [fetchFhirLabTicks.STARTED]: handleActionStart,
  [fetchFhirLabTicks.SUCCEEDED]: (state, action) => {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload;
  },
  [fetchFhirLabTicks.FAILED]: handleActionError,
  [setCurrentPatient]: (_, action) => action.payload.emrTicks,
  [clearCurrentPatient]: () => initialState,
});
